const React = require('react');

const { createContext, useContext } = React;

const NewsListContext = createContext();

const NewsListContextProvider = (props) => {
  const {
    assetsPath,
    children,
    lang,
    i18n,
    platform,
    changelogListContent,
    newsListContent,
    type,
    category,
    page,
    quantity,
    actualUrlPath,
    newsListContentTotal,
    changelogListTotal,
    product } = props;

  const buildUrlWithQueryParams = (queryParams = []) => {
    const actualURL = new URL(`http://teste.com${actualUrlPath}`);
    queryParams.forEach((queryItem) => {
      if (!queryItem?.value || queryItem?.value === '') {
        actualURL?.searchParams.delete(queryItem?.key);
        return;
      }
      actualURL?.searchParams?.set(queryItem?.key, queryItem?.value);
    });
    return `${actualURL?.pathname}${actualURL.search}`;
  };

  return (
    <div>
      <NewsListContext.Provider value={{
        lang,
        i18n,
        platform,
        changelogListContent,
        newsListContent,
        type: type || 'all',
        category,
        page,
        quantity,
        assetsPath,
        actualUrlPath,
        newsListContentTotal,
        changelogListTotal,
        product,
        buildUrlWithQueryParams,
      }}
      >
        {children}
      </NewsListContext.Provider>
    </div>
  );
};

const useNewsListContext = () => {
  const context = useContext(NewsListContext);
  return {
    ...context,
  };
};

module.exports = { useNewsListContext, NewsListContextProvider };
